/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { MessageResponseApiModel } from '../api-models/message-response';
// @ts-ignore
import { NewsCategoryApiModel } from '../api-models/news-category';
// @ts-ignore
import { PosApiModel } from '../api-models/pos';
// @ts-ignore
import { PosBonusesApiModel } from '../api-models/pos-bonuses';
// @ts-ignore
import { PosEquipmentsApiModel } from '../api-models/pos-equipments';
// @ts-ignore
import { PosFuelApiModel } from '../api-models/pos-fuel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ClientApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root'
})
export class POSApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: ClientApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Return all list of Point of sales (POS)
   * @endpoint get /pos
   * @param loyalty Loyalty ID
   * @param latitude Client latitude
   * @param longitude Client longitude
   * @param posType Pos type filter if need
   * @param onlineStoreOrderType Online store order type (only with pos_type eq \&#39;online-store\&#39;)
   * @param q Search string
   * @param favorite Filter by favorite (0/1)
   * @param recent Filter by recent (0/1)
   * @param category Category ID
   * @param onlyWithLocation Filter only with geolocation (0/1)
   * @param radius Filter by radius in Km (0 - without filtering)
   * @param onlineStore Return online store info (0/1)
   * @param referralProgram Return referral program info (0/1)
   * @param referralProgramInfoScope Scope for return referral program info
   * @param additionalServices Return additional services info (0/1)
   * @param paymentSystemsAvailability Return payment systems availability info (0/1)
   * @param paymentSystemsAvailabilityScope Scope for return payment systems availability info
   * @param fuelInfo Return fuel info (0/1)
   * @param fuelInfoRecommendedValuesPresets Return recommended values presets in fuel info (0/1)
   * @param fuelInfoPricesValues Return available prices by scope (not only base) in fuel info (0/1)
   * @param fuelInfoPricesValuesScope Scope for return available prices (not only base) in fuel info
   * @param fuelInfoTaxesValues Return taxes for price in fuel info (0/1)
   * @param fuelInfoMarginsValues Return margins for price in fuel info (0/1)
   * @param equipmentsInfo Return equipments info (0/1)
   * @param limit Result rows limit
   * @param fromRowOffset Result start row offset
   * @param sortByPriority Sort POS by priority (0/1)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPos(
    loyalty?: string,
    latitude?: number,
    longitude?: number,
    posType?: 'all' | 'offline' | 'pos' | 'road-tanker' | 'online-store',
    onlineStoreOrderType?: 'online-store' | 'fuel-taxi',
    q?: string,
    favorite?: 0 | 1,
    recent?: 0 | 1,
    category?: number,
    onlyWithLocation?: 0 | 1,
    radius?: number,
    onlineStore?: 0 | 1,
    referralProgram?: 0 | 1,
    referralProgramInfoScope?: 'full' | 'active-status-only',
    additionalServices?: 0 | 1,
    paymentSystemsAvailability?: 0 | 1,
    paymentSystemsAvailabilityScope?: 'list' | 'status',
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    limit?: number,
    fromRowOffset?: number,
    sortByPriority?: 0 | 1,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PosApiModel>>;
  public incustControllersClientClientPos(
    loyalty?: string,
    latitude?: number,
    longitude?: number,
    posType?: 'all' | 'offline' | 'pos' | 'road-tanker' | 'online-store',
    onlineStoreOrderType?: 'online-store' | 'fuel-taxi',
    q?: string,
    favorite?: 0 | 1,
    recent?: 0 | 1,
    category?: number,
    onlyWithLocation?: 0 | 1,
    radius?: number,
    onlineStore?: 0 | 1,
    referralProgram?: 0 | 1,
    referralProgramInfoScope?: 'full' | 'active-status-only',
    additionalServices?: 0 | 1,
    paymentSystemsAvailability?: 0 | 1,
    paymentSystemsAvailabilityScope?: 'list' | 'status',
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    limit?: number,
    fromRowOffset?: number,
    sortByPriority?: 0 | 1,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PosApiModel>>>;
  public incustControllersClientClientPos(
    loyalty?: string,
    latitude?: number,
    longitude?: number,
    posType?: 'all' | 'offline' | 'pos' | 'road-tanker' | 'online-store',
    onlineStoreOrderType?: 'online-store' | 'fuel-taxi',
    q?: string,
    favorite?: 0 | 1,
    recent?: 0 | 1,
    category?: number,
    onlyWithLocation?: 0 | 1,
    radius?: number,
    onlineStore?: 0 | 1,
    referralProgram?: 0 | 1,
    referralProgramInfoScope?: 'full' | 'active-status-only',
    additionalServices?: 0 | 1,
    paymentSystemsAvailability?: 0 | 1,
    paymentSystemsAvailabilityScope?: 'list' | 'status',
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    limit?: number,
    fromRowOffset?: number,
    sortByPriority?: 0 | 1,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PosApiModel>>>;
  public incustControllersClientClientPos(
    loyalty?: string,
    latitude?: number,
    longitude?: number,
    posType?: 'all' | 'offline' | 'pos' | 'road-tanker' | 'online-store',
    onlineStoreOrderType?: 'online-store' | 'fuel-taxi',
    q?: string,
    favorite?: 0 | 1,
    recent?: 0 | 1,
    category?: number,
    onlyWithLocation?: 0 | 1,
    radius?: number,
    onlineStore?: 0 | 1,
    referralProgram?: 0 | 1,
    referralProgramInfoScope?: 'full' | 'active-status-only',
    additionalServices?: 0 | 1,
    paymentSystemsAvailability?: 0 | 1,
    paymentSystemsAvailabilityScope?: 'list' | 'status',
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    limit?: number,
    fromRowOffset?: number,
    sortByPriority?: 0 | 1,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loyalty',
      <any>loyalty,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'latitude',
      <any>latitude,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'longitude',
      <any>longitude,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pos_type',
      <any>posType,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'online_store_order_type',
      <any>onlineStoreOrderType,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'q',
      <any>q,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'favorite',
      <any>favorite,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'recent',
      <any>recent,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'category',
      <any>category,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'only_with_location',
      <any>onlyWithLocation,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'radius',
      <any>radius,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'online_store',
      <any>onlineStore,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'referral_program',
      <any>referralProgram,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'referral_program_info_scope',
      <any>referralProgramInfoScope,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'additional_services',
      <any>additionalServices,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'payment_systems_availability',
      <any>paymentSystemsAvailability,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'payment_systems_availability_scope',
      <any>paymentSystemsAvailabilityScope,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info',
      <any>fuelInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_recommended_values_presets',
      <any>fuelInfoRecommendedValuesPresets,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_prices_values',
      <any>fuelInfoPricesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_prices_values_scope',
      <any>fuelInfoPricesValuesScope,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_taxes_values',
      <any>fuelInfoTaxesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_margins_values',
      <any>fuelInfoMarginsValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'equipments_info',
      <any>equipmentsInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'limit',
      <any>limit,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'from_row_offset',
      <any>fromRowOffset,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sort_by_priority',
      <any>sortByPriority,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PosApiModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return bonuses for Point of sales (POS)
   * @endpoint get /pos/{pos_id}/bonuses
   * @param posId Point of sales ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPosBonuses(
    posId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PosBonusesApiModel>;
  public incustControllersClientClientPosBonuses(
    posId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PosBonusesApiModel>>;
  public incustControllersClientClientPosBonuses(
    posId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PosBonusesApiModel>>;
  public incustControllersClientClientPosBonuses(
    posId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (posId === null || posId === undefined) {
      throw new Error(
        'Required parameter posId was null or undefined when calling incustControllersClientClientPosBonuses.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos/${this.configuration.encodeParam({
      name: 'posId',
      value: posId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/bonuses`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PosBonusesApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return Point of sales (POS)
   * @endpoint get /pos/{pos_id}
   * @param posId Point of sales ID
   * @param bonuses Return bonuses and accounts info (0/1)
   * @param coupons Return coupons info (0/1)
   * @param cardCategories Return card categories info (0/1)
   * @param fuelInfo Return fuel info (0/1)
   * @param fuelInfoRecommendedValuesPresets Return recommended values presets in fuel info (0/1)
   * @param fuelInfoPricesValues Return available prices by scope (not only base) in fuel info (0/1)
   * @param fuelInfoPricesValuesScope Scope for return available prices (not only base) in fuel info
   * @param fuelInfoPriceCustomersAccountInfo Include account customers data in prices (0/1)
   * @param fuelInfoPriceCustomersAccountInfoExtended Include account customers limits data (only if fuel_info_price_customers_account_info is 1)
   * @param fuelInfoTaxesValues Return taxes for price in fuel info (0/1)
   * @param fuelInfoMarginsValues Return margins for price in fuel info (0/1)
   * @param equipmentsInfo Return equipments info (0/1)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPosDetail(
    posId: string,
    bonuses?: 0 | 1,
    coupons?: 0 | 1,
    cardCategories?: 0 | 1,
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoPriceCustomersAccountInfo?: 0 | 1,
    fuelInfoPriceCustomersAccountInfoExtended?: 0 | 1,
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PosApiModel>;
  public incustControllersClientClientPosDetail(
    posId: string,
    bonuses?: 0 | 1,
    coupons?: 0 | 1,
    cardCategories?: 0 | 1,
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoPriceCustomersAccountInfo?: 0 | 1,
    fuelInfoPriceCustomersAccountInfoExtended?: 0 | 1,
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PosApiModel>>;
  public incustControllersClientClientPosDetail(
    posId: string,
    bonuses?: 0 | 1,
    coupons?: 0 | 1,
    cardCategories?: 0 | 1,
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoPriceCustomersAccountInfo?: 0 | 1,
    fuelInfoPriceCustomersAccountInfoExtended?: 0 | 1,
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PosApiModel>>;
  public incustControllersClientClientPosDetail(
    posId: string,
    bonuses?: 0 | 1,
    coupons?: 0 | 1,
    cardCategories?: 0 | 1,
    fuelInfo?: 0 | 1,
    fuelInfoRecommendedValuesPresets?: 0 | 1,
    fuelInfoPricesValues?: 0 | 1,
    fuelInfoPricesValuesScope?: 'all' | 'applicable' | 'minimal',
    fuelInfoPriceCustomersAccountInfo?: 0 | 1,
    fuelInfoPriceCustomersAccountInfoExtended?: 0 | 1,
    fuelInfoTaxesValues?: 0 | 1,
    fuelInfoMarginsValues?: 0 | 1,
    equipmentsInfo?: 0 | 1,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (posId === null || posId === undefined) {
      throw new Error(
        'Required parameter posId was null or undefined when calling incustControllersClientClientPosDetail.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'bonuses',
      <any>bonuses,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'coupons',
      <any>coupons,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'card_categories',
      <any>cardCategories,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info',
      <any>fuelInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_recommended_values_presets',
      <any>fuelInfoRecommendedValuesPresets,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_prices_values',
      <any>fuelInfoPricesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_prices_values_scope',
      <any>fuelInfoPricesValuesScope,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_price_customers_account_info',
      <any>fuelInfoPriceCustomersAccountInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_price_customers_account_info_extended',
      <any>fuelInfoPriceCustomersAccountInfoExtended,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_taxes_values',
      <any>fuelInfoTaxesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info_margins_values',
      <any>fuelInfoMarginsValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'equipments_info',
      <any>equipmentsInfo,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos/${this.configuration.encodeParam({
      name: 'posId',
      value: posId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PosApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return equipments of Point of sales (POS)
   * @endpoint get /pos/{pos_id}/equipments
   * @param posId Point of sales ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPosEquipments(
    posId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PosEquipmentsApiModel>;
  public incustControllersClientClientPosEquipments(
    posId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PosEquipmentsApiModel>>;
  public incustControllersClientClientPosEquipments(
    posId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PosEquipmentsApiModel>>;
  public incustControllersClientClientPosEquipments(
    posId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (posId === null || posId === undefined) {
      throw new Error(
        'Required parameter posId was null or undefined when calling incustControllersClientClientPosEquipments.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos/${this.configuration.encodeParam({
      name: 'posId',
      value: posId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/equipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PosEquipmentsApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return fuel controller of Point of sales (POS)
   * @endpoint get /pos/{pos_id}/fuel
   * @param posId Point of sales ID
   * @param recommendedValuesPresets Return recommended values presets in fuel info (0/1)
   * @param pricesValues Return available prices by scope (not only base) in fuel info (0/1)
   * @param pricesValuesScope Scope for return available prices (not only base) in fuel info
   * @param priceCustomersAccountInfo Include account customers data in prices (0/1)
   * @param priceCustomersAccountInfoExtended Include account customers limits data (only if price_customers_account_info is 1)
   * @param taxesValues Return taxes for price in fuel info (0/1)
   * @param marginsValues Return margins for price in fuel info (0/1)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPosFuel(
    posId: string,
    recommendedValuesPresets?: 0 | 1,
    pricesValues?: 0 | 1,
    pricesValuesScope?: 'all' | 'applicable' | 'minimal',
    priceCustomersAccountInfo?: 0 | 1,
    priceCustomersAccountInfoExtended?: 0 | 1,
    taxesValues?: 0 | 1,
    marginsValues?: 0 | 1,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PosFuelApiModel>;
  public incustControllersClientClientPosFuel(
    posId: string,
    recommendedValuesPresets?: 0 | 1,
    pricesValues?: 0 | 1,
    pricesValuesScope?: 'all' | 'applicable' | 'minimal',
    priceCustomersAccountInfo?: 0 | 1,
    priceCustomersAccountInfoExtended?: 0 | 1,
    taxesValues?: 0 | 1,
    marginsValues?: 0 | 1,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PosFuelApiModel>>;
  public incustControllersClientClientPosFuel(
    posId: string,
    recommendedValuesPresets?: 0 | 1,
    pricesValues?: 0 | 1,
    pricesValuesScope?: 'all' | 'applicable' | 'minimal',
    priceCustomersAccountInfo?: 0 | 1,
    priceCustomersAccountInfoExtended?: 0 | 1,
    taxesValues?: 0 | 1,
    marginsValues?: 0 | 1,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PosFuelApiModel>>;
  public incustControllersClientClientPosFuel(
    posId: string,
    recommendedValuesPresets?: 0 | 1,
    pricesValues?: 0 | 1,
    pricesValuesScope?: 'all' | 'applicable' | 'minimal',
    priceCustomersAccountInfo?: 0 | 1,
    priceCustomersAccountInfoExtended?: 0 | 1,
    taxesValues?: 0 | 1,
    marginsValues?: 0 | 1,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (posId === null || posId === undefined) {
      throw new Error(
        'Required parameter posId was null or undefined when calling incustControllersClientClientPosFuel.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'recommended_values_presets',
      <any>recommendedValuesPresets,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'prices_values',
      <any>pricesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'prices_values_scope',
      <any>pricesValuesScope,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info',
      <any>priceCustomersAccountInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info_extended',
      <any>priceCustomersAccountInfoExtended,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'taxes_values',
      <any>taxesValues,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'margins_values',
      <any>marginsValues,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos/${this.configuration.encodeParam({
      name: 'posId',
      value: posId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/fuel`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PosFuelApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return news for Point of sales (POS)
   * @endpoint get /pos/{pos_id}/news
   * @param posId Point of sales ID
   * @param sortByPriority Sort News by priority (0/1)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPosNews(
    posId: string,
    sortByPriority?: 0 | 1,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<NewsCategoryApiModel>>;
  public incustControllersClientClientPosNews(
    posId: string,
    sortByPriority?: 0 | 1,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<NewsCategoryApiModel>>>;
  public incustControllersClientClientPosNews(
    posId: string,
    sortByPriority?: 0 | 1,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<NewsCategoryApiModel>>>;
  public incustControllersClientClientPosNews(
    posId: string,
    sortByPriority?: 0 | 1,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (posId === null || posId === undefined) {
      throw new Error(
        'Required parameter posId was null or undefined when calling incustControllersClientClientPosNews.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sort_by_priority',
      <any>sortByPriority,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pos/${this.configuration.encodeParam({
      name: 'posId',
      value: posId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/news`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<NewsCategoryApiModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }
}
